module.exports = __webpack_public_path__ + "static/media/cannabis.fd54a38e.svg";